import { render, staticRenderFns } from "./DepositOrderItems.vue?vue&type=template&id=e1df4694&scoped=true"
import script from "./DepositOrderItems.vue?vue&type=script&lang=js"
export * from "./DepositOrderItems.vue?vue&type=script&lang=js"
import style0 from "./DepositOrderItems.vue?vue&type=style&index=0&id=e1df4694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1df4694",
  null
  
)

export default component.exports